import { render, staticRenderFns } from "./ClosedTradeCard.vue?vue&type=template&id=0822862c"
import script from "./ClosedTradeCard.vue?vue&type=script&lang=js"
export * from "./ClosedTradeCard.vue?vue&type=script&lang=js"
import style0 from "./ClosedTradeCard.vue?vue&type=style&index=0&id=0822862c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports